module.exports = __webpack_public_path__ + "img/kkb_laser.96da436b.jpg";